import { useContext, useEffect, useRef, useState } from "react";
import DriverSocketContext from "./context";
import { DriverStateDataType, DriverType } from "./types";
import DriverSocket, { FinalLocationType, ServiceTypeType } from "./socket";
import { SocketStateType } from "../base";
import { ETAType } from "../base/types";

export const useDriverSocket = () => useContext(DriverSocketContext);

export type DriverSocketStateSelectorType = (state: SocketStateType<DriverStateDataType>) => any;

const defaultSelector = (state: SocketStateType<DriverStateDataType>) => state;
const nullFunc = () => {};

export const useDriverSocketState = (selector: DriverSocketStateSelectorType = defaultSelector) => {
  const DriverSocket = useDriverSocket() as DriverSocket;
  const [state, setState] = useState(selector(DriverSocket.state));
  useEffect(() => {
    if (DriverSocket) {
      return DriverSocket.subscribe((nextState, socket) => {
        if (socket === DriverSocket) {
          setState(selector(nextState));
        }
      })
    }
    return nullFunc;
  }, [selector, DriverSocket]);
  return state;
}

export type DriverSocketActionsType = {
  sendLocationWithEta: () => void,
  goOnline: () => void,
  goOffline: () => void,
  rejectCall: () => void,
  acceptCall: (driver: DriverType, eta?: ETAType) => void,
  abortRide: (eta?: ETAType) => void,
  startRide: () => void,
  endRide: (serviceType: ServiceTypeType, waitingTimeInMinutes: Number, finalLocation: FinalLocationType) => void,
}

export const useDriverSocketActions = () => {
  const DriverSocket = useDriverSocket() as DriverSocket;
  const prevSocket = useRef<DriverSocket | null>(null);
  const prevActions = useRef<DriverSocketActionsType | {}>({});
  if (DriverSocket !== prevSocket.current) {
    // @ts-ignore
    prevActions.current.sendLocationWithEta = DriverSocket.sendLocationWithEta;
    // @ts-ignore
    prevActions.current.goOnline = DriverSocket.goOnline;
    // @ts-ignore
    prevActions.current.goOffline = DriverSocket.goOffline;
    // @ts-ignore
    prevActions.current.rejectCall = DriverSocket.rejectCall;
    // @ts-ignore
    prevActions.current.acceptCall = DriverSocket.acceptCall;
    // @ts-ignore
    prevActions.current.abortRide = DriverSocket.abortRide;
    // @ts-ignore
    prevActions.current.startRide = DriverSocket.startRide;
    // @ts-ignore
    prevActions.current.endRide = DriverSocket.endRide;
    // @ts-ignore
    prevSocket.current = DriverSocket;
  }
  return prevActions.current as DriverSocketActionsType;
};
